import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

// Types de relation, zones et services (annuaire des collaborateurs). Une seule requête, partagée par tous les écrans du module.
export default function useCollabReferentials() {
  const [data, setData] = useState({ relation_types: [], zones: [], services: [] });
  const [status, setStatus] = useState("loading"); // loading | ready | error

  const reload = useCallback(async () => {
    try {
      const { data: payload } = await api.get("/collaborators/referentials");
      setData(payload);
      setStatus("ready");
    } catch (e) {
      setStatus("error");
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const relationLabel = (code) => data.relation_types.find((r) => r.code === code)?.label || code;
  const zoneLabel = (code) => data.zones.find((z) => z.code === code)?.label || code;
  const serviceName = (id) => {
    if (!id) return null;
    const service = data.services.find((s) => s.id === id);
    return service ? service.name + (service.active ? "" : " (inactif)") : "Service";
  };

  return { ...data, status, reload, relationLabel, zoneLabel, serviceName };
}
